import { Link } from 'react-router-dom';
import { categories } from '@/mocks/category';

const categoryImages = [
  'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20with%20cherry%20blossom%20and%20traditional%20temple%2C%20soft%20pink%20and%20white%20color%20palette%2C%20dreamy%20atmosphere%2C%20clean%20minimalist%20design&width=400&height=300&seq=cat-riman&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20landscape%20with%20mountains%20and%20mist%2C%20traditional%20Chinese%20aesthetic%2C%20elegant%20minimalist%20design%2C%20soft%20natural%20colors&width=400&height=300&seq=cat-guoman&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20illustration%20with%20golden%20lighting%2C%20movie%20theater%20atmosphere%2C%20warm%20amber%20and%20gold%20tones%2C%20elegant%20minimalist%20design%2C%20soft%20bokeh%20background&width=400&height=300&seq=cat-juchang&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20illustration%20with%20old%20film%20texture%2C%20warm%20sepia%20tones%2C%20classic%20cartoon%20aesthetic%2C%20retro%20vibe%2C%20soft%20nostalgic%20atmosphere%2C%20minimalist%20design&width=400&height=300&seq=cat-jingdian&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Dynamic%20action%20illustration%20with%20fire%20and%20energy%20effects%2C%20intense%20warm%20orange%20and%20red%20tones%2C%20epic%20atmosphere%2C%20minimalist%20heroic%20design%2C%20powerful%20composition&width=400&height=300&seq=cat-rexue&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Romantic%20anime%20style%20illustration%20with%20pink%20cherry%20blossoms%20and%20soft%20sunlight%2C%20sweet%20gentle%20atmosphere%2C%20pastel%20pink%20and%20cream%20colors%2C%20dreamy%20minimalist%20design&width=400&height=300&seq=cat-lianai&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20illustration%2C%20neon%20lights%20and%20holographic%20elements%2C%20cyberpunk%20vibe%2C%20cool%20silver%20and%20teal%20tones%2C%20sleek%20modern%20minimalist%20design&width=400&height=300&seq=cat-kehuan&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Mysterious%20detective%20illustration%20with%20magnifying%20glass%20and%20shadows%2C%20noir%20atmosphere%2C%20deep%20purple%20and%20gray%20tones%2C%20suspenseful%20minimalist%20design%2C%20intriguing%20composition&width=400&height=300&seq=cat-xuanyi&orientation=landscape',
];

export default function CategoryShowcase() {
  const displayCategories = categories.slice(0, 8);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">
          探索动漫世界
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          八大分类，总有一款适合你
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {displayCategories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg aspect-[4/3] bg-background-100 cursor-pointer"
            >
              <img
                src={categoryImages[index]}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <div className="flex items-center gap-1.5">
                  <i className={`${cat.icon} text-background-50 text-sm`}></i>
                  <span className="text-sm font-medium text-background-50">{cat.name}</span>
                </div>
                <p className="text-xs text-background-300 mt-0.5 line-clamp-1">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}